<template>
    <div class="modal-carousel" v-if="show==true">
        <div class="modal-carousel-mask">

        </div>
        <div class="carousel">
            <Carousel v-model="value1">
                <CarouselItem v-for="(item,index) in imgList" :key="index">
                    <div class="demo-carousel"><img :src="item"  style="width: 800px;height: 800px"></div>
                </CarouselItem>

            </Carousel>
        </div>

        <div class="guanbi" @click.stop="childMethod">
            <i class="iconfont icon-guanbi">

            </i>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ShowSwiper",
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            imgList:{
                type:Array,
            }
        },
        data() {
            return{
                value1:0
            }
        },
        methods:{
            childMethod(){
                this.value1=0
                this.$parent.closeSwiper()
            }
        }
    }
</script>

<style scoped lang="scss">
    .modal-carousel {
        position: fixed;
        top: 0;
        left:0;
        width: 100%;
        height: 100%;
        z-index: 1000;
    }

    .guanbi {
        position: absolute;
        top: 20px;
        right: 60px;
        font-size: 36px;
        cursor: pointer;
        color: #a6a6a6;
    }

    .guanbi:hover {
        .icon-guanbi {
            color: #ffffff;
        }
    }
    .carousel {
        position: relative;
        width: 100%;

        top: 50%;
        text-align: center;
        margin-top: -400px;
    }

    ::v-deep.ivu-carousel {
        button {
            width: 72px;
            height: 72px;
        }

        .ivu-icon {
            font-size: 28px;
        }

        .ivu-carousel-dots-inside {
            display: none;
        }
    }

    .modal-carousel-mask {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        backdrop-filter: blur(2px);
        background-color: rgba(0, 0, 0, 0.8);
        /*img{*/
        /*  */
        /*}*/
    }
</style>
